<template>
  <div class="background-03">
    <v-layout row wrap justify-center mt-5>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc :vidTittle="'¿Como administrar el dinero?'" videoEmbed="ADMINISTRACIONDINERO16ComoAdministrarDinero(ant47).mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 sm3 text-xs-right class="hidden-xs-only" mt-5 hidden-xs-only>
        <image-app class="animated fadeInLeft" :imaSize="120" imaSrc="design/red-arrow" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 sm8 class="animated fadeInUp dura_1" mt-5>
        <ui-title-one titleAccess="La mejor manera de administrar el dinero y tener siempre un flujo de efectivo positivo es realizar un presupuesto." titleLevel="h1">
        <template slot="partOne">La mejor manera de administrar <br></template>
        <template slot="partTwo">el dinero y tener siempre un flujo de efectivo positivo </template>
        <template slot="partThree">es realizar un presupuesto.</template>
      </ui-title-one>
        <v-flex xs12 sm12 text-xs-center mt-2  hidden-xs-only>
          <image-app class="animated fadeInLeft" :imaSize="386" imaSrc="design/texture" imaAlt=""></image-app>
        </v-flex>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {
    };
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>


// WEBPACK FOOTER //
// davivienda-16.vue?abcb4ba6